// GL01 합배송출고 — moms-be 계약 타입.
// BE: GlobalPairOrderController (LOGISPRD-9603 조회 / 9604 저장 / 9606 다운로드)
//     GlobalPairOrderSyncController (LOGISPRD-14094 즉시 동기화 — 화주 파라미터 없음)
//     OutboundGlobalController (출고확정·잔여출고확정)

/** 화주 범위 — BE 3종(조회·저장·다운로드) 모두 이 값 외에는 400 을 낸다 (2026-07-10 회의 확정). */
export const MUSINSA_GLOBAL_SHIPPER_CODE = 'MUSINSAGLOBAL'
/** 목록 구간 크기 = BE size 상한 — GlobalPairOrderController @Max(1000), 넘기면 400(LOGISPRD-15271). */
export const GL01_FETCH_CHUNK_SIZE = 1000

/** 페이징 응답 봉투 — BE StandardResponse.PageInfoItems. */
export interface PageInfoItems<T> {
  items: T[]
  pageInfo?: { totalCount: number }
}

/** 조회·다운로드 공통 필터. 날짜는 yyyyMMdd (1.0 검색폼 형식 보존). */
export interface ConsolOutboundFilter {
  shipperCode: string
  orderDateFrom?: string
  orderDateTo?: string
  sourceOrderNumbers?: string[]
  inboundInvoiceNumber?: string
  globalInvoiceNumbers?: string[]
  orderNumbers?: string[]
  orderStatus?: string
  serviceType?: string
  outboundPlannedDateFrom?: string
  outboundPlannedDateTo?: string
}

export type ConsolOutboundSearchReq = ConsolOutboundFilter & { page: number; size: number }

export type ConsolOutboundDownloadReq = ConsolOutboundFilter & { password: string; detailedReason: string }

/** 조회 응답 행 — UI_PAIRORDER 1행. BE GlobalPairOrderRowDto 와 1:1. */
export interface ConsolOutboundRowDto {
  id: number
  shipperCode: string | null
  refNo1: number | null
  trsCountry: string | null
  sourceOrderNumber: string | null
  sourceOrderOptionNumber: number | null
  shipperDeliveryStatus: string | null
  orderStatus: string | null
  refMemo1: string | null
  refMemo2: string | null
  refMemo3: string | null
  refMemo4: string | null
  orderDate: string | null
  payDate: string | null
  venGroup: string | null
  shipperOrderStatus: string | null
  goodsOption: string | null
  orderQuantity: number | null
  goodsCode: number | null
  goodsType: string | null
  styleNo: string | null
  companyName: string | null
  goodsGroup1: string | null
  imageUrl: string | null
  brandName: string | null
  goodsLocation: string | null
  goodsName: string | null
  venGiType: string | null
  venPgiDate: string | null
  venCenterCode: string | null
  venCenterName: string | null
  venDeliveryType: string | null
  refCenter1: string | null
  refCenter2: string | null
  refCenter3: string | null
  refCenter4: string | null
  refCenter5: string | null
  refCenter6: string | null
  refCenter7: string | null
  ordererName: string | null
  ordererId: number | null
  ordererEmail: string | null
  shipperCutDate: string | null
  venGiDate: string | null
  refDate1: string | null
  refDate2: string | null
  deliveryDate: string | null
  refDate3: string | null
  refDate4: string | null
  refPeriod1: number | null
  refPeriod2: number | null
  refPeriod3: number | null
  refUrl1: string | null
  refLsp1: string | null
  refNo2: string | null
  refUrl2: string | null
  refLsp2: string | null
  consumerName: string | null
  consumerZipcode: string | null
  consumerState: string | null
  consumerCity: string | null
  consumerAddress1: string | null
  consumerAddress2: string | null
  inboundCenter: string | null
  outboundCenter: string | null
  inboundPlanDate: string | null
  inboundActDate: string | null
  outboundPlanDate: string | null
  outboundActDate: string | null
  consolidatedNo: string | null
  invoiceType: string | null
  serviceType: string | null
  clsDate: string | null
  cutSeq: number | null
  outboundClsDate: string | null
  outboundCutSeq: number | null
  inboundClsDate: string | null
  inboundCutSeq: number | null
  orderType: string | null
  trsType: string | null
  outboundInvoiceNo: string | null
  inboundInvoiceNo: string | null
  orderNo: string | null
  orderOptionNo: string | null
  rowType: string | null
}

/** 저장 요청 행 — updates 는 id 필수, 부분 수정(non-null 필드만 반영). */
export interface ConsolOutboundSaveRow {
  id: number
  refMemo1?: string
  refMemo2?: string
  refMemo3?: string
  refMemo4?: string
}

export interface ConsolOutboundSaveReq {
  creates: ConsolOutboundSaveRow[]
  updates: ConsolOutboundSaveRow[]
}

export interface ConsolOutboundSaveRes {
  createdCount: number
  updatedCount: number
  items: ConsolOutboundRowDto[]
}

/** 출고확정 구분 — RELEASE(출고확정) · REMAINING_RELEASE(잔여출고확정). 같은 엔드포인트를 공유한다. */
export type ConfirmOutboundDoType = 'RELEASE' | 'REMAINING_RELEASE'

export interface ConfirmOutboundReq {
  shipperCode: string
  doType: ConfirmOutboundDoType
  userId: string
}

/** 출고확정 응답은 StandardResponse 가 아니라 raw DTO 다 — meta.result 가 아니라 result 를 본다. */
export interface ConfirmOutboundRes {
  result: boolean
  message: string | null
}

/** 화면 표시용 행 — 컬럼 dataIndex(UPPER_SNAKE)에 맞춘 형태. `_id` 는 저장 대상 식별자. */
export type ConsolOutboundRow = Record<string, unknown> & { _id: number; _rowKey: string }
